import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/auth.service';
import { BaseAuthService } from '@libs/core/auth';

@NgModule({
  imports: [CommonModule],
})
export class AuthPtModule {
  constructor() {
    const module = inject(AuthPtModule, { optional: true, skipSelf: true });

    if (module) {
      throw new Error(`${AuthPtModule.name} should be imported only once!`);
    }
  }

  static forRoot(): ModuleWithProviders<AuthPtModule> {
    return {
      ngModule: AuthPtModule,
      providers: [
        AuthService,
        {
          provide: BaseAuthService,
          useExisting: AuthService,
        },
      ],
    };
  }
}
